interface SubmitButtonProps {
  isSubmitting: boolean
  disabled?: boolean
  loadingLabel: string
  label: string
}

export function SubmitButton({ isSubmitting, disabled, loadingLabel, label }: SubmitButtonProps) {
  return (
    <button
      type="submit"
      disabled={disabled || isSubmitting}
      className="w-full rounded-md bg-primary px-4 py-2.5 text-sm font-medium text-primary-foreground shadow-sm transition-colors duration-fast hover:bg-primary-hover disabled:cursor-not-allowed disabled:opacity-50"
    >
      {isSubmitting ? loadingLabel : label}
    </button>
  )
}
